import React from "react";
import PropTypes from "prop-types";
import Rating from "react-rating";

const SVGEmptyIcon = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
    >
        <path d="M12 5.173l2.335 4.817 5.305.732-3.861 3.71.942 5.27-4.721-2.524-4.721 2.525.942-5.27-3.861-3.71 5.305-.733 2.335-4.817zm0-4.586l-3.668 7.568-8.332 1.151 6.064 5.828-1.48 8.279 7.416-3.967 7.416 3.966-1.48-8.279 6.064-5.827-8.332-1.15-3.668-7.569z" />
    </svg>
);

const SVGIconFill = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
    >
        <path d="M12 .587l3.668 7.568 8.332 1.151-6.064 5.828 1.48 8.279-7.416-3.967-7.417 3.967 1.481-8.279-6.064-5.828 8.332-1.151z" />
    </svg>
);

export const getLabelFromRating = (rating) => {
    return `${rating} stars`;
};

const Stars = (props) => {
    const { name, value, fractions, onChange } = props;
    const rating = value.value;

    const handleChange = (rating) => {
        let fieldValue = value;

        fieldValue.value = rating;
        fieldValue.label = getLabelFromRating(rating);

        onChange(name, fieldValue);
    };

    return (
        <Rating
            emptySymbol={<SVGEmptyIcon />}
            fullSymbol={<SVGIconFill />}
            initialRating={rating}
            fractions={fractions}
            onChange={handleChange}
        />
    );
};

Stars.propTypes = {
    name: PropTypes.string.isRequired,
    value: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
    fractions: PropTypes.number,
};

Stars.defaultProps = {
    fractions: 2,
};

export default Stars;
